module.exports = __webpack_public_path__ + "media/EAJ_FW26-HALLOWEEN_LAVAGNA.30653aef.mp4";